export default __webpack_public_path__ + "static/media/YBLogoTxt.a95071c1.svg";